export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Vérification du numéro de téléphone',
        heading: 'Aidez-nous à protéger votre compte',
        otpHeading: 'Vérifiez vos messages et entrez votre code de vérification',
        subheading: 'Pour assurer la sécurité de votre compte, nous devons vérifier votre numéro de téléphone.',
        otpSubheading: 'Vous recevrez un code à l’adresse',
        otpSubheadingCont: 'si elle est liée à un compte Beauty Insider.',
        phoneOnFilePrefix: 'Confirmez le numéro se terminant par',
        phoneOnFileSuffix: 'pour recevoir un mot de passe à usage unique.',
        enterPhoneNumber: 'Numéro de téléphone',
        sendButton: 'Envoyer',
        cancelButton: 'Annuler',
        resendButton: 'Envoyez le courriel à nouveau',
        noAccessTextPrefix: 'Vous n’avez pas accès à ce téléphone? Envoyez un mot de passe à usage unique à l’adresse ',
        sendToEmailButton: 'Envoyer par courriel',
        emailVerification: 'Vérification de l’adresse courriel',
        privacyNote: 'Les renseignements recueillis ici ne seront utilisés qu’à des fins de vérification. Des frais de messagerie texte et de données peuvent s’appliquer. En cliquant sur « Envoyer », vous (1) acceptez la version actuelle de nos ',
        termsOfUse: 'CONDITIONS D’UTILISATION',
        privacyNoteEnd: ' et (2) confirmez avoir lu notre ',
        privacyPolicy: 'politique de confidentialité',
        errorInvalidPhone: 'Veuillez saisir un numéro de téléphone valide',
        errorPhoneMismatch: 'Le numéro que vous avez entré est incorrect. Veuillez essayer de nouveau.',
        tooManyAttempts: 'Tentatives épuisées',
        errorMaxAttempts: 'Le numéro de téléphone est incorrect et vous avez effectué trop de tentatives infructueuses, veuillez utiliser la vérification par courriel pour confirmer l’ouverture de session ou réessayer plus tard.',
        errorProfileNotFound: 'Profil introuvable. Veuillez vérifier votre adresse courriel et essayez de nouveau.',
        errorTokenExpired: 'Votre session a expiré. Veuillez ouvrir une nouvelle session.',
        errorInvalidEmail: 'Adresse courriel non valide.',
        errorMissingParameters: 'Des paramètres de saisie obligatoires sont manquants.',
        errorInternalServer: 'Une erreur s’est produite lors de la vérification. Veuillez réessayer plus tard.',
        errorNetwork: 'Nous ne pouvons pas envoyer un mot de passe à usage unique à votre téléphone pour l’instant, veuillez utiliser la vérification par courriel pour confirmer l’ouverture de session ou réessayer plus tard.',
        remainingAttempts: `${vars[0]} tentative${vars[0] !== 1 ? '' : 's'} restantes`,
        sending: 'Envoi en cours…',
        accessibilityPhoneInput: 'Saisissez votre numéro de téléphone à des fins de vérification',
        accessibilityError: 'Erreur',
        needAnotherSms: 'Vous avez besoin d’un autre SMS?',
        didntGetSms: 'Vous n’avez pas reçu le SMS? Renvoyer le code dans',
        seconds: 'secondes',
        errorInvalidOtp: 'Le code que vous avez entré est incorrect. Veuillez vérifier et essayer de nouveau.',
        errorInternalServerOTP: 'Nous ne pouvons pas confirmer votre mot de passe à usage unique pour l’instant. Veuillez réessayer plus tard.',
        errorMaxAttemptOtp: 'Tentatives épuisées. Veuillez réessayer plus tard.',
        gotIt: 'Compris',
        expiredOTPTitle: 'Mot de passe expiré',
        expiredOTP: 'Le code saisi a expiré. Veuillez renvoyer un nouveau code.',
        sendNewCode: 'Envoyer un nouveau code',
        infoTitle: 'Aidez-nous à protéger votre compte',
        infoMessage: 'Cela nous permet de nous assurer que vous seul avez accès à votre compte et de protéger vos renseignements contre tout accès non autorisé.'

    };

    return resources[label];
}
